export default __webpack_public_path__ + "static/media/480_store05-nl-mobile.fa08908d.png";